import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// styles
import colors from "core/colors";
import BodyText from "core/BodyText";
import { CreatorCountryStyled } from "./styles";

const CreatorCountry = () => {
    const { state } = useContext(AssetDownloadContext);

    const {
        asset: { country }
    } = state;

    if (!country) {
        return null;
    }

    return (
        <CreatorCountryStyled>
            <BodyText size="sm" copyColor={colors.primary.diamond}>
                {country}
            </BodyText>
        </CreatorCountryStyled>
    );
};

export default CreatorCountry;
